import { useState } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { Mail, Phone, MapPin } from "lucide-react";
import { toast } from "sonner";
import "./Contact.css";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { Facebook } from "lucide-react";


const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Thank you for your inquiry! We'll be in touch soon.");
    setFormData({ name: "", email: "", phone: "", company: "", message: "" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section className="contact-section">
      <NavBar />
      <div className="contact-container">
        <div className="contact-header animate-fade-in">
          <h2>
            Get in <span className="accent">Touch</span>
          </h2>
          <p>
            Ready to explore financing opportunities? Contact us today to discuss your needs.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info animate-fade-in">
            <Card className="contact-card">
              <div className="icon-wrapper3">
                <MapPin className="contact-icon" />
              </div>
              <div>
                <h5>Address</h5>
                <p>
                  Administration Office: Delta Tower |Chiromo Road | 13th Floor | Left wing <br />
                  Projects Office: ALFRALTI Conference Place | Waiyaiki way - Opp. Kianda School, near CCK<br />
                  P.O Box 11554 – 00100, Nairobi, Kenya
                </p>
              </div>
            </Card>

            <Card className="contact-card">
              <div className="icon-wrapper3">
                <Phone className="contact-icon" />
              </div>
              <div>
                <h5>Phone</h5>
                <p>
                  +254 757 926 268<br />
                </p>
              </div>
            </Card>

            <Card className="contact-card">
              <div className="icon-wrapper3">
                <Facebook className="contact-icon" />
              </div>
              <div>
                <h5>Facebook</h5>
                <p>
                  <a
                    href="https://web.facebook.com/benchmarksolutions.ke"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="facebook-link"
                  >
                    Visit our Facebook Page
                  </a>
                </p>
              </div>
            </Card>


            <Card className="contact-card">
              <div className="icon-wrapper3">
                <Mail className="contact-icon" />
              </div>
              <div>
                <h5>Email</h5>
                <p>info@benchmarksolutions.com</p>
              </div>
            </Card>

            <Card className="contact-card map-card">
              <div className="map-placeholder">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3199.3862174625474!2d36.801978399999996!3d-1.2655036000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f17403cbaee4b%3A0x74fe36a144a9109a!2sDelta%20Corner%20Towers!5e1!3m2!1sen!2ske!4v1763028162319!5m2!1sen!2ske" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

              </div>
            </Card>
          </div>

          <Card className="contact-form-card animate-fade-in" style={{ animationDelay: "150ms" }}>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Full Name *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  name="company"
                  placeholder="Company/Organization"
                  value={formData.company}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  as="textarea"
                  name="message"
                  placeholder="Tell us about your financing needs *"
                  rows={5}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Button type="submit" className="contact-btn w-100">
                Send Inquiry
              </Button>
            </Form>
          </Card>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default Contact;